import { render } from "./AiRadarPage.vue?vue&type=template&id=aa9ad960"
import script from "./AiRadarPage.vue?vue&type=script&lang=js"
export * from "./AiRadarPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__